// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUi from 'element-ui'
import router from './router';
import store from './store';
import axios from 'axios';
import myTable from './components/myTable';
import smTable from './components/smTable';
import echarts from 'echarts';
import './assets/icon/iconfont.css';
import './assets/icon2/iconfont.css';
import './assets/font/iconfont.css';
import util from '@/util/util'
import { isLmTokenExpiredPayload } from '@/views/aigc/aigcCreateHelpers'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Vant from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import 'vant/lib/index.css';
import '@/assets/js/common.js';
import SlideVerify from 'vue-monoplasty-slide-verify';
import Head from 'vue-head';
 
Vue.use(Head)
Vue.use(SlideVerify)

Vue.component('my-table', myTable);
Vue.component('sm-table', smTable);
Vue.use(ElementUi);
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.config.productionTip = false;

axios.interceptors.request.use(config => {
	if (util.getCookie('front_token')) {
		config.headers.Authorization = util.getCookie('front_token');
	}
	return config;
}, error => {
	return Promise.reject(error);
});

let authExpiredHandling = false;
let vueApp = null;

function handleLoginExpired() {
	if (authExpiredHandling) return;
	authExpiredHandling = true;
	store.commit('resetUserInfo');
	util.removeAllInfo();
	Toast.fail('登录已过期，请重新登录');
	if (vueApp) vueApp.$emit('lm-auth-expired');

	const route = router.currentRoute;
	const path = route.path || '';
	const isAigc = path.indexOf('/aigc') === 0;
	if (isAigc && route.name === 'aigc_create') {
		setTimeout(() => { authExpiredHandling = false; }, 800);
		return;
	}
	if (isAigc) {
		router.replace({
			path: '/aigc/login',
			query: { redirect: encodeURIComponent(route.fullPath || '/aigc/create') },
		});
	} else if (route.meta && route.meta.requireAuth) {
		router.replace({
			path: '/login',
			query: { redirect: route.fullPath },
		});
	}
	setTimeout(() => { authExpiredHandling = false; }, 800);
}

axios.interceptors.response.use(
	(response) => {
		const res = response.data;
		if (isLmTokenExpiredPayload(res)) {
			handleLoginExpired();
			return Promise.reject(new Error('登录过期'));
		}
		return response;
	},
	(error) => {
		const resp = error && error.response;
		if (resp) {
			const data = resp.data;
			if (resp.status === 401 || isLmTokenExpiredPayload(data)) {
				handleLoginExpired();
				return Promise.reject(new Error('登录过期'));
			}
		}
		return Promise.reject(error);
	}
);

//修改axios原型链
Vue.prototype.Axios = axios;
// 打包接口地址
Vue.prototype.Axios.defaults.baseURL = process.env.BASE_URL;
Vue.prototype.ImageUrl = process.env.BASE_URL;
// 跳转前台地址
Vue.prototype.FrontUrl = process.env.TEMPLATE_URL;
Vue.prototype.Echarts = echarts;
// 延迟多少秒后跳转页面
Vue.prototype.WatingTime = 1000;

router.beforeEach((to, from, next) => {
	if (to.meta.requireAuth) { //判断该路由是否需要登录
		const hasToken = util.getCookie('front_token');
		if (hasToken) {
			next();
		}
		else {
			// 清空store
			store.commit('resetUserInfo');
			// 清除cookie
			util.removeAllInfo();
			// window.location.href = process.env.TEMPLATE_URL + '/login/';
			const loginPath = to.path && String(to.path).indexOf('/aigc') === 0 ? '/aigc/login' : '/login';
			next({
			  path: loginPath,
			  query: { redirect: to.fullPath } //将跳转的路由path作为参数，登录成功后跳转该路由
			})
		}
	} else if(to.matched.length == 0) {
	  // 匹配不到页面到登录
	  next({path: '/404/'});
	}else {
	 //  let hasToken = util.getCookie('front_token');
		// if (hasToken) {
		// 	next({
		// 	  path: 'index',
		// 	  query: { redirect: to.fullPath } //将跳转的路由path作为参数，登录成功后跳转该路由
		// 	})
		// }
		// else {
		  next();
		// }
	}
})

/** 线上发版后 index 与 chunk 哈希不一致时，懒加载失败则刷新拉取最新资源 */
router.onError((err) => {
	const msg = err && (err.message || String(err)) || '';
	const isChunkFailed =
		/Loading chunk [\d]+ failed/i.test(msg) ||
		/Loading CSS chunk [\d]+ failed/i.test(msg) ||
		/ChunkLoadError/i.test(msg);
	if (isChunkFailed) {
		const key = 'lm_chunk_reload';
		if (!window.sessionStorage.getItem(key)) {
			window.sessionStorage.setItem(key, '1');
			window.location.reload();
			return;
		}
		window.sessionStorage.removeItem(key);
	}
});

router.afterEach(() => {
	try {
		window.sessionStorage.removeItem('lm_chunk_reload');
	} catch (e) {
		/* ignore */
	}
});

const app = new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
});
vueApp = app;



// WEBPACK FOOTER //
// ./src/main.js